/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-mixed-operators */
import React, {
  useContext,
  useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { Modal } from '@madeeasy/universal-login';
import { usePathname, useSearchParams } from 'next/navigation';
import { format } from 'date-fns';
import GET_ENTITY_BY_SLUG from '../../gql/queries/get-entity-by-slug.gql';
import GET_SCHOLARSHIP_BY_SLUG from '../../gql/queries/scholarship.gql';
import Spinner from '../../icons/spinner';
import SEOHead from '../seo-head';
import CarouselSection from '../course-landing/carousel';
import TestimonialSection from '../course-landing/testimonial-section';
import FAQSectionMinimal from '../course-landing/faqs';
import NoDataFound from '../shared/DataNotFound';
import {
  domainBaseUrl, isWebView, encodeBase64String, getCurrentOrgName,
} from '../../utils/helpers';
import location from '../../../public/assets/Loc_ation.svg';
import threeBuildings from '../../../public/assets/three-buildings.svg';
import { useUser } from '../../contexts/ssr-user-context';
import ProfilePopUp from '../profile/AddProfilePopUp';
import GET_ADMIT_CARD_LINK from '../../gql/queries/download-admit-card.gql';
import GET_SCORE_CARD_LINK from '../../gql/queries/download-score-card.gql';
import { ToastContext } from '../../contexts/toast-context-with-provider';
import GET_REGISTRATION_DETAILS from '../../gql/queries/get-promotional-event-registration.gql';
import INIT_SCHOLARSHIP_MOCK_TEST from '../../gql/mutations/init-scholarship-mock-test.gql';

function ScholarshipTest({ initialScholarshipData, initialEntityData }) {
  const isPrefixed = process.env.NEXT_PUBLIC_USE_BASE_PATH === 'true';
  console.log('sPrefixed:', isPrefixed, process.env.NEXT_PUBLIC_USE_BASE_PATH);
  const oldPortalId = ['4be423bd-b517-40ca-b1f5-996b50577f20'];
  const orgName = getCurrentOrgName();
  const isMadeeasy = orgName === 'madeeasyprime' || orgName === 'madeeasy';
  const router = useRouter();
  const { slug } = router.query;
  const { user } = useUser();
  const { showToast } = useContext(ToastContext);
  const isLoggedIn = user?.id;
  const profilePicture = user?.profile?.accountDetails?.profilePicture;
  const [profilePopUpOpen, setProfilePopUpOpen] = useState(false);
  const [scholarshipData, setScholarshipData] = useState(initialScholarshipData?.getPromotionalEventBySlug);
  const [showLogin, setShowLogin] = useState(false);
  const [registerMode, setRegisterMode] = useState('');
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const onlineRef = useRef(null);
  const offlineRef = useRef(null);

  function toggleModal() {
    setShowLogin(false);
  }

  const { data: entity, loading: entityLoading } = useQuery(GET_ENTITY_BY_SLUG, {
    variables: {
      slug,
      lang: 'en',
    },
    skip: !slug || !!initialEntityData,
    errorPolicy: 'ignore',
  });

  const {
    data, loading, error, refetch,
  } = useQuery(GET_SCHOLARSHIP_BY_SLUG, {
    variables: {
      slug,
    },
    skip: !!initialScholarshipData,
  });

  const { data: scholarshipRegistrationData } = useQuery(GET_REGISTRATION_DETAILS, {
    variables: { promotionalEventId: initialScholarshipData?.getPromotionalEventBySlug?.id },
  });

  const isUserAlreadyRegistered = (scholarshipData?.isAccountRegistered) || data?.getPromotionalEventBySlug?.isAccountRegistered;
  const onlineExams = scholarshipData?.testPapers?.filter((test) => test.mode === 'ONLINE' && test.registrationInfo?.isRegistered === true) || [];
  const offlineExams = scholarshipData?.testPapers?.filter((test) => test.mode === 'OFFLINE' && test.registrationInfo?.isRegistered === true) || [];
  const isRegistrationClosed = scholarshipData?.registrationsClosed || data?.getPromotionalEventBySlug?.registrationsClosed || false;
  const metaJson = JSON.parse(scholarshipData?.meta?.metaJson || '{}');
  const statusTracking = metaJson?.statusTracking || {};
  const handleRedirect = (mode = registerMode) => {
    const queryParams = new URLSearchParams();
    if (mode) queryParams.set('registerMode', encodeBase64String(mode));
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const encodeUrl = encodeURIComponent(`${domainBaseUrl()}${isUserAlreadyRegistered ? `${isPrefixed ? '/prep' : ''}/open-mock-test/${slug}/exam-list` : `${isPrefixed ? '/prep' : ''}/open-mock-test/${slug}/registration${queryString}`}`);
    const params = new URLSearchParams(searchParams.toString());
    params.set('redirectTo', encodeUrl);
    const newUrl = `${pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };

  const handleLoginRedirect = () => {
    if (searchParams.has('redirectTo')) return;

    const baseUrl = domainBaseUrl();
    const currentPath = window.location.pathname;

    const redirectTo = encodeURIComponent(`${baseUrl}${currentPath}`);
    const newUrl = `${currentPath}?redirectTo=${redirectTo}`;

    window.history.replaceState(null, '', newUrl);
  };

  useEffect(() => {
    const container = document.getElementById('html-entities-container');
    if (!container) return;

    const scripts = container.querySelectorAll('script');

    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      newScript.text = oldScript.text;

      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [scholarshipData]);

  const getExamMeta = (exam) => {
    if (!exam) return {};

    const meta = exam?.meta || {};
    const examDate = exam?.examDateTime ? new Date(exam?.examDateTime) : null;
    const examStartTime = exam?.displayExamStartTime ? new Date(exam?.displayExamStartTime) : null;
    const examEndTime = exam?.displayExamEndTime ? new Date(exam?.displayExamEndTime) : null;
    const testDate = examDate ? format(examDate, 'do MMM yyyy (EEEE)') : '';
    const timeStr = examStartTime && examEndTime ? `${format(examStartTime, 'hh:mm a')} to ${format(examEndTime, 'hh:mm a')}` : '';

    const syllabusList = Array.isArray(meta?.syllabusList) ? meta.syllabusList : [];
    const instructionsList = Array.isArray(meta?.instructionsList) ? meta.instructionsList : [];

    return {
      meta,
      testDate,
      timeStr,
      syllabusList,
      instructionsList,
    };
  };

  const [adminCardDownloadLink] = useLazyQuery(GET_ADMIT_CARD_LINK);
  const [scoreCardDownloadLink] = useLazyQuery(GET_SCORE_CARD_LINK);

  const handleDownloadAdmitCard = async ({ exam }) => {
    if ((profilePicture === '' || !profilePicture) && JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.admitCardSettings?.isPhotoRequired) {
      setProfilePopUpOpen(true);
      return;
    }
    try {
      const { data: cardData } = await adminCardDownloadLink({
        variables: {
          slug,
          testPaperId: exam?.testPaperId,
          promotionalEventId: scholarshipData?.id,
        },
      });
      if (cardData?.getPromotionalEventBySlug?.testPapers[0]?.registrationInfo?.adminCardDownloadLink?.admitCardLink) {
        window.open(cardData?.getPromotionalEventBySlug?.testPapers[0]?.registrationInfo?.adminCardDownloadLink?.admitCardLink, '_blank');
      }
    } catch (err) {
      console.error('Error downloading admit card:', err);
    }
  };

  const [initMockTest] = useMutation(INIT_SCHOLARSHIP_MOCK_TEST);

  const handleMockTestClick = (testPaperId, linkId, state) => {
    if (!testPaperId || !state) return;

    try {
      // Android WebView bridge
      // eslint-disable-next-line no-undef
      if (typeof Android !== 'undefined' && typeof Android.handleMockTestClick === 'function') {
        // eslint-disable-next-line no-undef
        Android.handleMockTestClick(testPaperId, linkId, state);
      }

      // iOS WebView bridge
      if (
        window?.webkit
        && window.webkit?.messageHandlers
        && window.webkit?.messageHandlers?.handleMockTestClick_iOS
      ) {
        window.webkit.messageHandlers.handleMockTestClick_iOS.postMessage({
          testPaperId,
          linkId,
          state,
        });
      }
    } catch (err) {
      console.error('handleMockTestClick bridge error:', err);
    }
  };

  const handleAttemptTest = async ({ exam }) => {
    if (isWebView()) {
      handleMockTestClick(
        exam?.testPaperId,
        exam?.linkId,
        'attempt',
      );
      return;
    }

    const isOldPortal = oldPortalId.includes(scholarshipData?.id);

    if (isOldPortal) {
      window.location.href = exam?.registrationInfo?.attemptLink;
      return;
    }

    try {
      const response = await initMockTest({
        variables: {
          testPaperId: exam?.testPaperId,
        },
      });

      if (!response?.data?.initScholarshipMockTest?.success) {
        showToast(response?.data?.initScholarshipMockTest?.message);
        return;
      }

      window.location.href = `/prep/attempt-mocktest?linkId=${exam?.linkId}`;
    } catch (err) {
      showToast('Something went wrong. Please try again.');
    }
  };

  const handleSolutionChallenge = ({ exam }) => {
    if (isWebView()) {
      handleMockTestClick(
        exam?.testPaperId,
        exam?.linkId,
        'solution_challenge',
      );
      return;
    }
    window.location.href = `/prep/attempt-mocktest?linkId=${exam?.linkId}&isSolution=true`;
  };

  const handleViewResult = ({ exam }) => {
    // if ((profilePicture === '' || !profilePicture) && JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.admitCardSettings?.isPhotoRequired) {
    //   setProfilePopUpOpen(true);
    //   return;
    // }
    if (isWebView()) {
      handleMockTestClick(exam?.testPaperId, exam?.linkId, 'result');
      return;
    }
    const isOldPortal = oldPortalId.includes(scholarshipData?.id);

    if (isOldPortal) {
      window.location.href = exam?.registrationInfo?.resultLink;
      return;
    }

    window.location.href = `/prep/mock-test-result?linkId=${exam?.linkId}`;
  };

  const handleResumeTest = ({ exam }) => {
    if (isWebView()) {
      handleMockTestClick(exam?.testPaperId, exam?.linkId, 'attempt');
      return;
    }
    window.location.href = `/prep/attempt-mocktest?linkId=${exam?.linkId}`;
  };

  const handleDownloadScoreCard = async ({ exam }) => {
    if (profilePicture === '' || !profilePicture) {
      setProfilePopUpOpen(true);
      return;
    }
    try {
      const { data: cardData } = await scoreCardDownloadLink({
        variables: {
          slug,
          testPaperId: exam?.testPaperId,
          promotionalEventId: scholarshipData?.id,
          scoreCardDownloadLinkTestPaperId2: exam?.testPaperId,
        },
      });
      if (cardData?.getPromotionalEventBySlug?.testPapers[0]?.registrationInfo?.scoreCardDownloadLink?.scoreCardLink) {
        window.open(cardData?.getPromotionalEventBySlug?.testPapers[0]?.registrationInfo?.scoreCardDownloadLink?.scoreCardLink, '_blank');
      }
    } catch (err) {
      console.error('Error downloading score card:', err);
    }
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (!isLoggedIn) {
      const currentPath = window.location.pathname;
      const redirectTo = searchParams.get('redirectTo');
      const newUrl = `${currentPath}?redirectTo=${redirectTo}`;
      if (redirectTo) {
        setShowLogin(true);
        window.history.replaceState(null, '', newUrl);
      }
    }
  }, [router.isReady]);

  useEffect(() => {
    if (initialScholarshipData?.getPromotionalEventBySlug) {
      setScholarshipData(initialScholarshipData?.getPromotionalEventBySlug);
    } else if (data?.getPromotionalEventBySlug) {
      setScholarshipData(data?.getPromotionalEventBySlug);
    }
  }, [data, initialScholarshipData]);

  useEffect(() => {
    const detachFns = [];

    const attachHandlers = (container, mode) => {
      if (!container?.current) return;

      const registerButton = container.current.querySelector('.register-button');

      if (!registerButton) return;

      registerButton.removeAttribute('disabled');
      registerButton.removeAttribute('aria-disabled');
      registerButton.classList.remove('registration-closed');
      registerButton.style.background = '';
      registerButton.style.cursor = '';
      registerButton.style.opacity = '';
      registerButton.style.pointerEvents = '';

      let buttonText = registerButton.textContent || '';
      let shouldDisable = false;
      let onClick = null;

      if (statusTracking?.resultDeclared) {
        buttonText = 'View Result';
        onClick = (e) => {
          if (!isLoggedIn) {
            e.preventDefault();
            setShowLogin(true);
            handleLoginRedirect();
          } else showToast('You are not registered for this test. Please ensure you are logged in using the phone/email you used while registering.');
        };
      } else if (statusTracking?.solutionChallengeAvailable) {
        buttonText = 'Challenge Solutions';
        onClick = (e) => {
          if (!isLoggedIn) {
            e.preventDefault();
            setShowLogin(true);
            handleLoginRedirect();
          } else showToast('You are not registered for this test. Please ensure you are logged in using the phone/email you used while registering.');
        };
      } else if (mode === 'offline' && statusTracking?.admitCardReleased) {
        buttonText = 'Download Admit Card';
        onClick = (e) => {
          if (!isLoggedIn) {
            e.preventDefault();
            setShowLogin(true);
            handleLoginRedirect();
          } else showToast('You are not registered for this test. Please ensure you are logged in using the phone/email you used while registering.');
        };
      } else if (mode === 'online' && (statusTracking?.admitCardReleased || statusTracking?.onlineCredentialReleased)) {
        buttonText = 'Attempt Test';
        onClick = (e) => {
          if (!isLoggedIn) {
            e.preventDefault();
            setShowLogin(true);
            handleLoginRedirect();
          } else showToast('You are not registered for this test. Please ensure you are logged in using the phone/email you used while registering.');
        };
      } else if (isRegistrationClosed) {
        buttonText = 'Registrations Closed';
        shouldDisable = true;
        registerButton.classList.add('registration-closed');
        registerButton.style.background = '#9CA3AF';
        registerButton.style.cursor = 'not-allowed';
        registerButton.style.opacity = '0.85';
        registerButton.style.pointerEvents = 'auto';

        onClick = (e) => {
          e.preventDefault();
          if (!isLoggedIn) {
            setShowLogin(true);
            handleLoginRedirect();
          } else {
            showToast('Registrations are closed for this Exam.');
          }
        };
      } else {
        // Default: register flow
        onClick = (e) => {
          e.preventDefault();
          setRegisterMode(mode);
          const queryParams = new URLSearchParams();
          if (mode) queryParams.set('registerMode', encodeBase64String(mode));
          const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
          if (isLoggedIn) {
            if (isUserAlreadyRegistered) {
              window.location.href = `${domainBaseUrl()}${isPrefixed ? '/prep' : ''}/open-mock-test/${slug}/exam-list`;
            } else {
              window.location.href = `${domainBaseUrl()}${isPrefixed ? '/prep' : ''}/open-mock-test/${slug}/registration${queryString}`;
            }
          } else {
            handleRedirect(mode);
            setShowLogin(true);
          }
        };
      }

      registerButton.textContent = buttonText;
      if (shouldDisable) {
        registerButton.setAttribute('disabled', 'true');
        registerButton.setAttribute('aria-disabled', 'true');
      }

      if (onClick) {
        registerButton.addEventListener('click', onClick);
        detachFns.push(() => {
          registerButton.removeEventListener('click', onClick);
        });
      }
    };

    attachHandlers(onlineRef, 'online');
    attachHandlers(offlineRef, 'offline');

    return () => {
      detachFns.forEach((fn) => fn());
    };
  }, [scholarshipData, isLoggedIn, isUserAlreadyRegistered, router, slug, isRegistrationClosed, statusTracking]);

  if ((entityLoading && !initialEntityData) || (loading && !initialScholarshipData)) {
    return <Spinner fullPage />;
  }

  if (!scholarshipData) {
    return <NoDataFound onClick={() => (error ? router.reload() : router.push('/home'))} buttonText={error ? 'Retry' : 'Go to Home'} />;
  }

  return (
    <div className="w-full bg-white flex flex-col justify-center items-center gap-[16px] sm:gap-[25px] md:gap-[34px] mt-5 mx-auto">
      {
        (initialEntityData?.getEntityBySlug?.meta || entity?.getEntityBySlug?.meta)
         && <SEOHead data={initialEntityData?.getEntityBySlug?.meta || entity?.getEntityBySlug?.meta} />
      }

      <div className="w-full flex flex-col justify-start items-center gap-[14px] sm:gap-[20px] md:gap-[10px] px-4 md:px-6 mb-2">
        {
          JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.banner
          && (
          <div className="relative w-full aspect-[26/9]">
            <Image
              src={JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.banner}
              alt="banner"
              className="object-cover"
              fill
              priority
            />
          </div>
          )
        }
        <div className="flex gap-[10px] sm:gap-[11px] md:gap-[12px] items-center mt-12">
          <div className="w-[6px]  md:w-[6px] h-[56px] md:h-[32px] bg-[#ff5761]" />
          <h1 className="text-[24px] sm:text-[27px] md:text-[30px]  font-semibold leading-[36px] sm:leading-[40px] md:leading-[45px] text-[#000]">
            {scholarshipData?.name}
          </h1>
        </div>
        {
          isUserAlreadyRegistered && (onlineExams.length > 0 || offlineExams.length > 0)
          && (
          <div className="w-full flex flex-col gap-[16px] sm:gap-[20px] py-[16px] sm:py-[20px] md:py-[26px]">
            {
            offlineExams.length > 0
          && (
          <div>
            <h2 className="text-[24px] font-semibold text-[#1562AF] mb-4">Offline Test</h2>
            {
            offlineExams.map((exam) => {
              const ExamData = getExamMeta(exam);
              return (
                <div key={exam?.testPaperId} className={`w-full px-4 py-[16px] sm:py-[20px] ${statusTracking?.scoreCardReleased ? 'md:py-[29px]' : 'md:py-[26px]'} mx-auto shadow-md bg-white border border-[#DEDEDEC7] relative mt-2`}>
                  <p className="text-[20px] font-semibold mb-1">{exam?.name}</p>
                  <div className="flex items-center gap-2 text-[16px] flex-wrap">
                    <span className="font-semibold">
                      Test Date:
                      {' '}
                      {' '}
                      {ExamData?.testDate}
                      {' '}
                      | Timings:
                    </span>
                    {ExamData?.timeStr}
                  </div>
                  {
                    exam?.registrationInfo?.isRegistered && <span className="bg-[#DFF4CE] text-[#264909]  text-xs font-medium px-2 py-1 rounded absolute top-2 right-2">Registered</span>
                  }
                  {
                    (exam?.session || exam?.categoryName || exam?.registrationInfo?.admitCardAvailable)
                    && (
                    <div className="mt-1 flex items-center gap-4 flex-wrap">
                      {/* {(exam?.session || exam?.categoryName) && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={openBook} alt="date" width={16} height={16} />
                        <span className="font-semibold">
                          {exam?.categoryName}
                        </span>
                        (
                          {exam?.session}
                        )
                      </div>
                    )} */}
                      {exam?.registrationInfo?.admitCardAvailable && exam?.registrationInfo?.admitCard?.center && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={threeBuildings} alt="date" width={16} height={16} />
                        <span className="font-semibold">{exam?.registrationInfo?.admitCard?.center}</span>
                      </div>
                      )}
                      {exam?.registrationInfo?.admitCardAvailable && exam?.registrationInfo?.admitCard?.location && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={location} alt="date" width={16} height={16} />
                        <span className="font-semibold">{exam?.registrationInfo?.admitCard?.location}</span>
                      </div>
                      )}
                    </div>
                    )
                  }

                  {ExamData?.syllabusList.length > 0
                  && (
                  <div className="mt-4">
                    <h5 className="text-base font-semibold mb-2">Test Syllabus</h5>
                    <ul className="list-disc pl-5 text-sm space-y-1 flex gap-20 items-center">
                      {ExamData?.syllabusList.map((syllabus) => (
                        <li key={syllabus}>{syllabus}</li>
                      ))}
                    </ul>
                  </div>
                  )}
                  <div className="mt-4 flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                    {
                  ExamData?.instructionsList.length > 0
                    && (
                    <div className="w-full md:w-5/6">
                      <h5 className="text-base font-semibold mb-2">Test Instruction</h5>
                      <ul className="list-disc pl-5 text-sm grid grid-cols-1 md:grid-cols-2 gap-1">
                        {ExamData?.instructionsList.map((instruction) => (
                          <li key={instruction}>{instruction}</li>
                        ))}
                      </ul>
                    </div>
                    )
                  }
                    <div className="w-full md:w-1/6 flex md:justify-end items-center md:absolute md:bottom-6 md:right-4">
                      {
                    exam?.registrationInfo?.admitCardAvailable && !exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive && !exam?.registrationInfo?.mockTestLink?.isResultDeclared
                    && (
                    <button
                      type="button"
                      className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto"
                      onClick={() => handleDownloadAdmitCard({ exam })}
                    >
                      Download Admit Card
                    </button>
                    )
                  }
                      {
                         exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive && !oldPortalId.includes(scholarshipData?.id)
                          && (
                          <button type="button" className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto" onClick={() => handleSolutionChallenge({ exam })}>
                            Challenge Solutions
                          </button>
                          )
                  }
                      <div className="flex flex-col gap-1">
                        {
                          (
                            (
                              !oldPortalId.includes(scholarshipData?.id)
                              && exam?.registrationInfo?.mockTestLink?.isResultDeclared
                              && exam?.registrationInfo?.isRegistered
                              && exam?.linkId
                              && exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'completed'
                            )
                            || (
                              oldPortalId.includes(scholarshipData?.id)
                              && exam?.registrationInfo?.isResultDeclared
                            )
                          ) && (
                            <button
                              type="button"
                              className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto"
                              onClick={() => handleViewResult({ exam })}
                            >
                              View Result
                            </button>
                          )
                        }

                        {
                         JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.statusTracking?.scoreCardReleased && exam?.registrationInfo?.mockTestLink?.isResultDeclared && !oldPortalId.includes(scholarshipData?.id) && exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'completed' && exam?.registrationInfo?.isRegistered && isMadeeasy
                          && (
                          <button type="button" className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto" onClick={() => handleDownloadScoreCard({ exam })}>
                            Download Score Card
                          </button>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          }
          </div>
          )
          }
            {
            onlineExams.length > 0
            && (
            <div>
              <h2 className="text-[24px] font-semibold text-[#1562AF] mb-4">Online Test</h2>
              {
              onlineExams.map((exam) => {
                const ExamData = getExamMeta(exam);
                return (
                  <div key={exam?.testPaperId} className={`w-full px-4 py-[16px] sm:py-[20px] ${statusTracking?.scoreCardReleased ? 'md:py-[29px]' : 'md:py-[26px]'} mx-auto shadow-md bg-white border border-[#DEDEDEC7] relative mt-2`}>
                    <p className="text-[20px] font-semibold mb-1">{exam?.name}</p>
                    <div className="flex items-center gap-2 text-[16px] flex-wrap">
                      <span className="font-semibold">
                        Test Date:
                        {' '}
                        {' '}
                        {ExamData?.testDate}
                        {' '}
                        |
                      </span>
                      <span className="font-semibold"> Timings:</span>
                      {ExamData?.timeStr}
                    </div>
                    <span className="bg-[#DFF4CE] text-[#264909]  text-xs font-medium px-2 py-1 rounded absolute top-2 right-2">Registered</span>
                    {
                    exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'completed' && !exam?.registrationInfo?.mockTestLink?.isResultDeclared && !exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive && <span className="bg-blue-200 text-black  text-xs font-medium px-2 py-1 rounded absolute right-0 md:right-2 -top-5 md:top-10 ">Your test is submitted. Thank You !</span>
                    }
                    {
                    !exam?.registrationInfo?.mockTestLink?.attemptInfo?.isTestInit && exam?.registrationInfo?.mockTestLink?.isStartCutOffDatePassed && !exam?.registrationInfo?.mockTestLink?.isResultDeclared && !exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive
                    && <span className="bg-blue-200 text-black  text-xs font-medium px-2 py-1 rounded absolute right-0 md:right-2 -top-5 md:top-10 ">Test is already Started. You cannot attempt now !</span>
                    }
                    {
                    exam?.registrationInfo?.admitCardAvailable
                    && (
                    <div className="mt-1 flex items-center gap-4 flex-wrap">
                      {/* {(exam?.session || exam?.categoryName) && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={openBook} alt="date" width={16} height={16} />
                        <span className="font-semibold">
                          {exam?.categoryName}
                        </span>
                        (
                          {exam?.session}
                        )
                      </div>
                      )} */}
                      {exam?.registrationInfo?.admitCard?.center && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={threeBuildings} alt="date" width={16} height={16} />
                        <span className="font-semibold">{exam?.registrationInfo?.admitCard?.center}</span>
                      </div>
                      )}
                      { exam?.registrationInfo?.admitCard?.location && (
                      <div className="flex items-center gap-2 text-[14px]">
                        <Image src={location} alt="date" width={16} height={16} />
                        <span className="font-semibold">{exam?.registrationInfo?.admitCard?.location}</span>
                      </div>
                      )}
                    </div>
                    )
                  }
                    {
                    ExamData?.syllabusList.length > 0
                    && (
                    <div className="mt-4">
                      <h5 className="text-base font-semibold mb-2">Test Syllabus</h5>
                      <ul className="list-disc pl-5 text-sm space-y-1 flex gap-20 items-center">
                        {ExamData?.syllabusList.map((syllabus) => (
                          <li key={syllabus}>{syllabus}</li>
                        ))}
                      </ul>
                    </div>
                    )
                    }
                    <div className="mt-4 flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                      {
                    ExamData?.instructionsList.length > 0
                      && (
                      <div className="w-full md:w-5/6">
                        <h5 className="text-base font-semibold mb-2">Test Instruction</h5>
                        <ul className="list-disc pl-5 text-sm grid grid-cols-1 md:grid-cols-2 gap-1">
                          {ExamData?.instructionsList.map((instruction) => (
                            <li key={instruction}>{instruction}</li>
                          ))}
                        </ul>
                      </div>
                      )
                      }
                      <div className="w-full md:w-1/6 flex md:justify-end items-center md:absolute md:bottom-6 md:right-4">
                        {
                          (
                            (
                              !oldPortalId.includes(scholarshipData?.id)
                              && !exam?.registrationInfo?.mockTestLink?.isResultDeclared
                              && !exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive
                              && !exam?.registrationInfo?.mockTestLink?.isStarted
                              && !exam?.registrationInfo?.mockTestLink?.isFinalSubmissionDatePassed
                            )
                            || (
                              oldPortalId.includes(scholarshipData?.id)
                              && !exam?.registrationInfo?.isTestLive
                            )
                          ) && (
                            <div className="relative group w-full md:w-auto">
                              <button
                                type="button"
                                disabled
                                className="bg-gray-400 text-white text-sm font-medium px-4 py-2 w-full md:w-auto cursor-not-allowed opacity-50"
                              >
                                Attempt Test
                              </button>
                              {exam?.displayExamStartTime && (
                                <div className="absolute bottom-full left-1/2 -translate-x-2/3 mb-2 z-10 hidden group-hover:block w-max max-w-xs bg-gray-800 text-white text-xs rounded px-3 py-1.5 text-center pointer-events-none">
                                  This link will be active at
                                  {' '}
                                  {format(new Date(exam.displayExamStartTime), 'hh:mm a')}
                                  <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
                                </div>
                              )}
                            </div>
                          )
                        }
                        {
                          (
                            (
                              !oldPortalId.includes(scholarshipData?.id)
                              && !exam?.registrationInfo?.mockTestLink?.isResultDeclared
                              && !exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive
                              && exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'unattempted'
                              && exam?.registrationInfo?.mockTestLink?.isStarted
                              && !exam?.registrationInfo?.mockTestLink?.isFinalSubmissionDatePassed
                              && (!exam?.registrationInfo?.mockTestLink?.isStartCutOffDatePassed || exam?.registrationInfo?.mockTestLink?.attemptInfo?.isTestInit)
                            )
                            || (
                              oldPortalId.includes(scholarshipData?.id)
                              && exam?.registrationInfo?.isTestLive
                            )
                          ) && (
                            <button
                              type="button"
                              className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto
                                         disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50"
                              onClick={() => handleAttemptTest({ exam })}
                            >
                              Attempt Test
                            </button>
                          )
                        }
                        {
                          exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'attempted' && exam?.registrationInfo?.mockTestLink?.isStarted && !exam?.registrationInfo?.mockTestLink?.isFinalSubmissionDatePassed
                          && (
                          <button type="button" className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto" onClick={() => handleResumeTest({ exam })}>
                            Resume Test
                          </button>
                          )
                        }

                        {
                         exam?.registrationInfo?.mockTestLink?.isSolutionChallengeActive && !oldPortalId.includes(scholarshipData?.id)
                          && (
                          <button type="button" className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto" onClick={() => handleSolutionChallenge({ exam })}>
                            Challenge Solutions
                          </button>
                          )
                        }

                        <div className="flex flex-col gap-1">
                          {
                          (
                            (
                              !oldPortalId.includes(scholarshipData?.id)
                              && exam?.registrationInfo?.mockTestLink?.isResultDeclared
                              && exam?.registrationInfo?.isRegistered
                              && exam?.linkId
                              && exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'completed'
                            )

                            || (
                              oldPortalId.includes(scholarshipData?.id)
                              && exam?.registrationInfo?.isResultDeclared
                            )
                          ) && (
                            <button
                              type="button"
                              className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto"
                              onClick={() => handleViewResult({ exam })}
                            >
                              View Result
                            </button>
                          )
                        }
                          {
                         JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.statusTracking?.scoreCardReleased && exam?.registrationInfo?.mockTestLink?.isResultDeclared && !oldPortalId.includes(scholarshipData?.id) && exam?.registrationInfo?.mockTestLink?.attemptInfo?.attemptStatus === 'completed' && exam?.registrationInfo?.isRegistered && isMadeeasy
                          && (
                          <button type="button" className="bg-[#1562AF] text-white text-sm font-medium px-4 py-2 w-full md:w-auto" onClick={() => handleDownloadScoreCard({ exam })}>
                            Download Score Card
                          </button>
                          )
                        }
                        </div>
                      </div>
                    </div>

                  </div>
                );
              })
            }
            </div>
            )
            }
          </div>
          )
         }
        {
          JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.offlineRegistration && (!scholarshipRegistrationData?.getPromotionalEventRegistration || scholarshipRegistrationData?.getPromotionalEventRegistration?.meta?.examMode === 'offline') && ((onlineExams.length === 0 && offlineExams.length === 0) || (onlineExams.length > 0 && offlineExams.length === 0 && scholarshipData?.allowMultiModeTestPapers))
          && (
          <div className="w-full">
            <h2 className="text-[24px] font-semibold text-[#1562AF] mb-2">Offline Test</h2>
            <div
              className="w-full"
              ref={offlineRef}
              dangerouslySetInnerHTML={{ __html: JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.offlineRegistration }}
            />
          </div>
          )
        }
        {
          JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.onlineRegistration && (!scholarshipRegistrationData?.getPromotionalEventRegistration || scholarshipRegistrationData?.getPromotionalEventRegistration?.meta?.examMode !== 'offline') && ((onlineExams.length === 0 && offlineExams.length === 0) || (offlineExams.length > 0 && onlineExams.length === 0 && scholarshipData?.allowMultiModeTestPapers))
          && (
          <div className="w-full">
            <h2 className="text-[24px] font-semibold text-[#1562AF] mb-2">Online Test</h2>
            <div
              className="w-full"
              ref={onlineRef}
              dangerouslySetInnerHTML={{ __html: JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.onlineRegistration }}
            />
          </div>
          )
        }
        {
          scholarshipRegistrationData?.getPromotionalEventRegistration?.testPapers?.length === 0
          && (
            <div className="w-full text-left">
              <p className="text-[16px] font-semibold">
                Paper Selection Pending !
                <span className="text-[#1562AF] cursor-pointer" onClick={() => { window.location.href = `${domainBaseUrl()}${isPrefixed ? '/prep' : ''}/open-mock-test/${slug}/exam-list`; }}> Click here</span>
                {' '}
                to resume your registration
              </p>
            </div>
          )
        }
        {
          JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.htmlEntities
          && (
          <div
            id="html-entities-container"
            className="w-full py-8"
            dangerouslySetInnerHTML={{ __html: JSON.parse(scholarshipData?.meta?.metaJson || '{}')?.htmlEntities }}
          />
          )
        }
      </div>
      {
          scholarshipData?.demoVideos.length > 0 && isUserAlreadyRegistered
          && (
          <CarouselSection
            title="Demo Videos"
            subtitle="Get a Glimpse of the Classroom"
            data={scholarshipData?.demoVideos}
            type="video"
          />
          )
        }
      {
          scholarshipData?.recommendedCourses.length > 0 && isUserAlreadyRegistered
          && (
          <CarouselSection
            title="Other Recommended Courses"
            subtitle="Selected Lectures Just for You"
            data={scholarshipData?.recommendedCourses}
            type="course"
          />
          )
        }
      {
          scholarshipData?.testimonials.length > 0
          && (
          <TestimonialSection
            testimonials={scholarshipData?.testimonials}
            heading="Testimonials"
            subheading="Voices of Our Happy Students"
          />
          )
        }
      {
          scholarshipData?.faqs.length > 0
          && <FAQSectionMinimal faqs={scholarshipData?.faqs} heading="Frequently Asked Questions" />
        }
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
      {
        profilePopUpOpen && <ProfilePopUp isOpen={profilePopUpOpen} onClose={() => setProfilePopUpOpen(false)} profilePicture={profilePicture} refetch={refetch} />
      }
    </div>
  );
}
ScholarshipTest.propTypes = {
  initialScholarshipData: PropTypes.object,
  initialEntityData: PropTypes.object,
};

export default ScholarshipTest;
